import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PersonOutline from '@material-ui/icons/PersonOutline';
import EmailOutline from '@material-ui/icons/MailOutline';
import Ratings from '../RateMyAgent/Ratings';
import TooltipText from '../../constants/TooltipText';
import cardStyles from './AgencyCards_mui.scss';
import compactStyles from './AgencyCards_compact.scss';

const ListingCountLabel = (count, url, label) => {
  return (
    count > 0 ?
      <Link to={url}>
        <div className="d-flex flex-column align-items-md-center justify-content-md-center">
          <div><Typography variant="subtitle1">{count}</Typography></div>
          <div><Typography variant="subtitle2" className="text-nowrap">{label}</Typography></div>
        </div>
      </Link>
      : null
  );
};

const AgencyCard = (props) => {
  const {
    agency,
    rmaAgencyProfiles,
  } = props;
  const { dynamicFields, agencyURL, logoURL, name, address, referrer, agencyId } = agency
    ? agency
    : {};
  const rmaData = rmaAgencyProfiles?.data?.[agencyId];
  const {
    overallStars,
    reviewCount,
    branding: {
      logo: rmaLogo,
    } = {},
    agencyProfileTrixelImgUrl,
  } = rmaData || {};
  let agencyLogo = logoURL?.includes('agency-logo-placeholder-mui.svg') && rmaLogo ? rmaLogo : logoURL;
  if (!agencyLogo) agencyLogo = '/assets/images/agency-logo-placeholder-mui.svg';

  const {currentRecentSalesCount, currentRentalListingCount, currentSaleListingCount} = dynamicFields;
  const formattedAddress = address ? address.formattedAddress : undefined;
  let bgColor = undefined;
  if (agency?.bannerHex) bgColor = `${agency.bannerHex.indexOf('#') === 0 ? '' : '#'}${agency.bannerHex}`;

  const dests = ['agency', 'contact-form', 'sold', 'for-rent', 'for-sale', 'reviews-section'];
  let urls = {};
  dests.map((destination) => {
    urls[destination] = {pathname: '/'};
    if (agencyURL) {
      urls[destination].pathname = agencyURL;
      if (destination !== 'agency') urls[destination].hash = destination;
    }
    if (referrer) urls[destination].state = {referrer: referrer};
  });

  const forceMobile = (props?.forceMobile && props.forceMobile) || (typeof window !== 'undefined' && window?.oth_device !== 'desktop');
  const styles = forceMobile ? compactStyles : cardStyles;

  return (
    <div className={styles.agencyCardMui}>
      {agencyProfileTrixelImgUrl && <img loading="lazy" alt="" style={{height: 1, width: 1}} src={agencyProfileTrixelImgUrl} />}
      <Paper className={`${styles.agencyCard} mb-3 position-relative`}>
        <div className={styles.body} style={{'--customBG': bgColor}}>
          <div className={styles.logo}>
            {agencyLogo &&
            <Link to={urls['agency']}>
              <img src={agencyLogo} onError={({currentTarget}) => {currentTarget.onerror = null; currentTarget.src = '/assets/images/agency-logo-placeholder-mui.svg';}} />
            </Link>
            }
          </div>
          <div className={`flex-grow-1 ${styles.agencyName}`}>
            <div className={styles.h2}><Typography variant="h2"><Link to={urls['agency']}>{name}</Link></Typography></div>
            <div><Typography variant="caption">{formattedAddress && <div>{formattedAddress}</div>}</Typography></div>
            <div className={`mt-1 ${styles.rmaAgencyRatingContainer}`}>
              <Ratings
                id="agency-search-card"
                overallStars={overallStars}
                reviewCount={reviewCount}
                reviewsUrl={urls['reviews-section']}
                containerClass={styles.rmaRatingContainer}
                ratingClass={styles.rmaRating}
                reviewCountClass={`${styles.rmaReviewCount}${overallStars ? ' ml-3' : ''}`}
                tooltipText={TooltipText.RMA_AGENCY_DATA_DISCLAIMER}
              />
            </div>
          </div>
          <div className={`d-flex ${styles.listingCounts}`}>
            {ListingCountLabel(currentSaleListingCount, urls['for-sale'], 'For Sale')}
            {ListingCountLabel(currentRentalListingCount, urls['for-rent'], 'For Rent')}
            {ListingCountLabel(currentRecentSalesCount, urls['sold'], 'Sold')}
          </div>
          <div className={`d-flex justify-content-between h-100 ${styles.cardButtonContainer}`}>
            <div className="flex-grow-1"><Button color="secondary" variant="outlined" component={Link} to={urls['agency']} className="w-100" startIcon={<PersonOutline fontSize={'small'} className={styles.buttonIcon} />}><span className={styles.buttonLabel}>View&nbsp;</span>Profile</Button></div>
            <div className="flex-grow-1">{urls['agency'] && <Button color="primary" variant="contained" component={Link} to={urls['contact-form']} className="w-100" startIcon={<EmailOutline fontSize={'small'} className={styles.buttonIcon} />}>Contact<span className={styles.buttonLabel}>&nbsp;Agency</span></Button>}</div>
          </div>
        </div>
      </Paper>
    </div>
  );
};

AgencyCard.propTypes = {
  agency: PropTypes.object,
  rmaAgencyProfiles: PropTypes.object,
  forceMobile: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    rmaAgencyProfiles: state.rmaAgencyProfiles,
  };
};

export default connect(mapStateToProps)(AgencyCard);
